export default "__VITE_PUBLIC_ASSET__f74aa025__"